import { isLikeNotificationDetails } from "@scrile/api-provider/dist/api/LikeProvider";
import { isMessageSubjectDetails } from "@scrile/api-provider/dist/api/MessagesProvider";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import emitter from "@/lib/emitter";
import { NotificationData } from "@/types";
import { EVENTS } from "@/const";

export default function(notification: Notification): NotificationData | false {
  if (isLikeNotificationDetails(notification.details) && isMessageSubjectDetails(notification.details.content)) {
    emitter.emit(EVENTS.MESSAGES_LIKED_MESSAGE, { notification });
  }
  return false;
}
